import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconLocation } from '@redteclab/icons'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../../../global-config'
import { useNowGeneralContext } from '../../../../now'
import { TENANT } from '../../../../tenant'
import { useProductPageContext } from '../../productPageContext'
import { useProductPrices } from '../hooks/useProductPrices'
import { useShowProductDeliveryDates } from '../hooks/useShowProductDeliveryDates'

import { ProductBuyBoxDeliveryInfo } from './ProductBuyBoxDeliveryInfo'
import { ProductBuyBoxStockStatus } from './ProductBuyBoxStockStatus'

export const ProductBuyBoxDeliveryStatusInfoBox: FC = () => {
  const { currentPrescriptionType, nowDetails, offerId, product } =
    useProductPageContext()
  const { tenant } = useGlobalConfigContext()
  const { nowGeneralData, productPageNowDialogControls } =
    useNowGeneralContext()
  const zip = nowGeneralData.zipSupportInfo?.zip

  const { isOfferMirakl } = useProductPrices({
    currentPrescriptionType,
    offerId,
    product,
  })

  const shouldShowDeliveryDates = useShowProductDeliveryDates()
  const shouldStackDeliveryInfo =
    shouldShowDeliveryDates && tenant !== TENANT.COM
  const shouldShowZipChangeLink =
    nowDetails.nowCustomerJourneyEnabled && !isOfferMirakl

  return (
    <>
      <div
        className={clsx(
          'flex',
          shouldShowZipChangeLink || shouldStackDeliveryInfo
            ? 'flex-col gap-1'
            : 'w-full flex-row justify-between',
        )}
      >
        <ProductBuyBoxStockStatus />
        <ProductBuyBoxDeliveryInfo />
      </div>
      {shouldShowZipChangeLink ? (
        <Button
          onClick={productPageNowDialogControls.handleOpen}
          size="medium"
          startIcon={<IconLocation aria-hidden />}
          variant="text"
        >
          <span className="sr-only">
            <FormattedMessage id="now.link.location.aria-label" />
          </span>
          {zip ?? <FormattedMessage id="now.link.zip" />}
        </Button>
      ) : null}
    </>
  )
}
